import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'external-service-rules' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
